import React, { useRef, useCallback } from "react";

import { useReleases } from "../Releases/hooks/useReleases";

import { FilepickerInput, FooterButton } from "./styles";

const ReleaseUploadButton = () => {
    const { handleFileChange, clearOutErrorMessage } = useReleases();

    const filePickerRef = useRef();

    const handleOpenFilePicker = useCallback(
        e => {
            e.preventDefault();
            clearOutErrorMessage();
            filePickerRef.current.click();
        },
        [filePickerRef]
    );

    return (
        <>
            <FooterButton onClick={e => handleOpenFilePicker(e)}>
                Upload a Release
            </FooterButton>
            <FilepickerInput
                ref={filePickerRef}
                type="file"
                multiple
                value={""} // need empty val for same file name upload
                onChange={e => handleFileChange(e)}
            />
        </>
    );
};

export default ReleaseUploadButton;
